<template>
  <div class="grid-view">
    <div
      class="main-content"
      type="primary"
    >
      <search-item
        config-module="410015204"
        :reset="true"
        :show-simple="false"
        :expand-adv="true"
        :auto-init="true"
        :custom-search-items="customSearchItems"
        no="1"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <el-button type="primary" no="2" @click="sendOfficeBtnClickHandler()">{{ $t('CargoMsg.Cargo_SettlementNotice') }}</el-button>
          <el-button type="primary" no="3" @click="viewDetailBtnClickHandler()">{{ $t('CargoMsg.Cargo_ViewDetail') }}</el-button>
          <el-button type="primary" no="4" @click="sendDLClickHandler()">{{ $t('CargoMsg.Cargo_NotifyHq') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="410015204"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="410015204"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <bill-notice-result-window
      v-if="billNoticeResultWindow.visible"
      :visible="billNoticeResultWindow.visible"
      :select-items="billNoticeResultWindow.selectItems"
      @close="billNoticeResultWindow.visible = false"
      @refresh="toQuery"
    />
    <bill-actual-amount-detail-window
      v-if="billActualAmountDetailWindow.visible"
      :visible="billActualAmountDetailWindow.visible"
      :actual-amount="billActualAmountDetailWindow.actualAmount"
      @close="billActualAmountDetailWindow.visible = false"
    />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import AmountSumMaster from '@/views/cargo/v0/Clearing/components/FinanceChargeSearch/AmountSumMaster'
import BillOverseasSCenterGrid from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/grid/billOverseasSCenterGrid'
import QueryBillActualAmountCondition
  from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/query/queryBillActualAmountCondition'
import BillActualAmountGrid from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/grid/billActualAmountGrid'
import { queryActualAmountAdv, sendHQOfficeEmail } from '@/api/clearing/actualAmount'
import BillNoticeResultWindow from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/billNoticeResultWindow'
import BillActualAmountDetailWindow
  from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/billActualAmountDetailWindow'
import { getBankAccountList } from '@/api/bankAccount'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import { formatNumberToThousands } from '@/utils'
import { recordSelectedStatus } from '@/utils/agGrid'
export default {
  name: 'NewBillActualAmount',
  components: { BillActualAmountDetailWindow, BillNoticeResultWindow, BillActualAmountGrid, QueryBillActualAmountCondition, BillOverseasSCenterGrid, AmountSumMaster, searchItem },
  data() {
    return {
      gridParams: {},
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', colId: 'accountId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', colId: 'currency', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffAmount'), field: 'amount', colId: 'amount', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffPerson'), field: 'verificationBy', colId: 'verificationBy', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffDate'), field: 'verificationDate', colId: 'verificationDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_PayReceiveDate'), field: 'payReceiveDate', colId: 'payReceiveDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_OurBank'), field: 'ourBank', colId: 'ourBank', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.getPaymentType(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_VoucherNo'), field: 'bankWaterNo', colId: 'bankWaterNo', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_SettlementAgent'), field: 'settlementAgentId', colId: 'settlementAgentId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SendConfirmationStatus'), field: 'SendConfirmationStatus', colId: 'SendConfirmationStatus', width: 200,
          valueFormatter: (params) => {
            return this.confirmStatesLabFunc(params.data)
          } },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'), colId: 'jobNo', field: 'jobNo'
        },
        { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'poNo', colId: 'poNo', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_PaymentMethod'), field: 'type', colId: 'type', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.getPaymentType(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AmountOfActualCollectionPayment'), field: 'amount', colId: 'amount', width: 100,
          valueFormatter: (params) => {
            return formatNumberToThousands(ColumnUtils.formatNumberReturnZero(params.value, 2))
          }
        }, {
          headerName: this.$t('WriteOff.exchangeGainsAndLosses'),
          field: 'diffChange',
          colId: 'diffChange',
          width: 100,
          valueFormatter: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          }
        }, {
          headerName: this.$t('WriteOff.financialCharges'),
          field: 'financialCost',
          colId: 'financialCost',
          width: 100,
          valueFormatter: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          }
        }, {
          headerName: this.$t('WriteOff.oddment'),
          field: 'clearOdd',
          colId: 'clearOdd',
          width: 100,
          valueFormatter: (params) => {
            const val = formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
            return val === '0.00' ? '' : val
          }
        }
      ],
      fullscreenLoading: null,
      isAdvancedQuery: false, // 是否为高级查询
      rowData: [],
      numAll: 100,
      numSelected: 0,
      sumCredit: '',
      sumDebit: '',
      selectedRows: [],
      selectRow: null,
      billNoticeResultWindow: {
        visible: false,
        selectItems: []
      },
      billActualAmountDetailWindow: {
        visible: false,
        actualAmount: {}
      },
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 100
      },
      filterJson: {},
      customSearchItems: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onRowSelected: this.onGridRowClickedEvent,
        onSelectionChanged: (event) => {
          this.selectedRows = event.api.getSelectedRows()
        }
      }
    }
  },
  async created() {
    await this.initCustomSearchItems()
  },
  methods: {
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      this.filterJson.isAdvancedQuery = true
      this.filterJson.oversea = true
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryActualAmountAdv(this.filterJson).then(res => {
        this.handleQueryData(res)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    toSimpleQuery(data) {
    },
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      this.rowData = []
      for (const data of res.data.list) {
        if (data) {
          this.rowData.push(data)
        }
      }
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.loadingEnd()
      selectedStatus.revert()
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
      this.selectedRows = []
      this.selectRow = null
    },
    sendOfficeBtnClickHandler() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffRecord'))
        return
      }
      let isAllSend = false
      for (const ac of selectRows) {
        for (const ch of ac.clearHistory) {
          if (ch.confirmState === 0) {
            isAllSend = true
            break
          }
        }
      }
      if (!isAllSend) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AllBillingHasBeenSentToBranches'))
        return
      }
      this.billNoticeResultWindow.visible = true
      this.billNoticeResultWindow.selectItems = selectRows
    },
    confirmStatesLabFunc(act) {
      let isConfirm = true
      for (const clear of act.clearHistory) {
        if (clear.confirmState !== 2) {
          isConfirm = false
          break
        }
      }
      if (isConfirm) {
        return this.$t('CargoMsg.Cargo_Confirmed')
      }
      if (this.isAllSend(act.clearHistory)) {
        return this.$t('CargoMsg.Cargo_Sent')
      }
      if (this.clearState < 1) {
        if (this.isSectionSend(act.clearHistory)) {
          return this.$t('CargoMsg.Cargo_SendPartial')
        }
      }
      if (this.clearState === 1) {
        if (this.isSectionSend(act.clearHistory)) {
          return this.$t('CargoMsg.Cargo_SendPartial')
        }
        if (this.isSectionConfirm(act.clearHistory)) {
          return this.$t('CargoMsg.Cargo_PartialConfirmation')
        }
      } else {
        if (this.isSectionConfirm(act.clearHistory)) {
          return this.$t('CargoMsg.Cargo_PartialConfirmation')
        }
      }
      return this.$t('CargoMsg.Cargo_NotSent')
    },
    isSectionConfirm(clearHistory) {
      const state = []
      for (const clear of clearHistory) {
        state.push(clear.confirmState)
      }
      if (state.includes(1) && state.includes(2)) {
        return true
      }
      return false
    },
    isAllSend(clearHistory) {
      for (const clear of clearHistory) {
        if (clear.confirmState !== 1) {
          return false
        }
      }
      return true
    },
    isSectionSend(clearHistory) {
      const state = []
      for (const clear in clearHistory) {
        state.push(clear.confirmState)
      }
      if (state.includes(0) && state.includes(1) && state.includes(2)) {
        return true
      }
      if (state.includes(0) && state.includes(1)) {
        return true
      }
      return false
    },
    sendDLClickHandler() {
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmAndNotityHQ'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading()
        sendHQOfficeEmail().then(res => {
          this.fullscreenLoading.close()
          if (res.data === 'ok') {
            this.$message.success(this.$t('CargoMsg.sendEmailSuccess'))
          } else if (res.data !== 'fail') {
            this.$message.warning(res.data)
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_SendFailed'))
          }
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    // 自定义高级查询
    async initCustomSearchItems() {
      const res = await getBankAccountList(this.$store.getters.currentOfficeUuid)
      // 银行名称和银行账号要去重
      const bankList = []
      if (res.data && res.data.length > 0) {
        for (const item of res.data) {
          const bank = item.bankChineseName
          if (bankList.length === 0) {
            bankList.push(item)
          } else {
            const index = bankList.findIndex(p => p.bankChineseName === bank)
            if (index < 0) {
              bankList.push(item)
            }
          }
        }
      }
      // 我方银行名称
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'advanceSelect'
      searchField.multiple = 0
      searchField.action = 2
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemValue = []
      searchField.itemLabel = 'Invoice.invoice_sp8'
      searchField.itemName = 'actualAmount.OURBANK'
      searchField.headers = ['银行名称']
      searchField.fields = ['bankChineseName']
      searchField.tagName = 'bankChineseName'
      searchField.tagValue = 'bankChineseName'
      searchField.dataCacheKey = 'static_data_BankAccount'
      searchField.dataProvider = bankList
      this.customSearchItems.push(searchField.formatObj2Json())
    },
    viewDetailBtnClickHandler() {
      const selectRow = this.selectRow
      if (!selectRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffRecord'))
        return
      }
      this.billActualAmountDetailWindow.actualAmount = selectRow
      this.billActualAmountDetailWindow.visible = true
    },
    onGridRowClickedEvent(event) {
      this.selectRow = event.data
    }
  }
}
</script>

<style lang="scss">
.bill-overseas-s-center-view{
  .totalLabel{
    margin-top: 6px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
